import React from 'react';
import { FieldState } from 'components/common/form-utils/form-state';
import { TextField } from 'components/common/TextField';
import Select from 'react-select';
import generateLocator from 'utils/generate-locator';

const FieldEditor = ({ fieldName, field }: { fieldName: string, field: FieldState }) => {
  const labelProp = {
    'aria-label': `Edit value of field ${field}`,
    'id': generateLocator(fieldName, 'edit'),
  };
  if (fieldName === 'isValid') {
    return <input
      {...labelProp}
      type='checkbox'
      checked={field.value === 'true'}
      onChange={() => field.setBoolean(!field.getBoolean())} />;
  } else if (fieldName === 'discountType') {
    return <div className='w-3/4 mx-auto flex flex-row'>
      <Select
        id='discountType'
        className={'w-48 border border-2'}
        styles={{
          control: (provided) => ({ ...provided, 'border': 'none' }),
        }}
        options={[{ value: 'Percentage', label: 'Percentage' }, { value: 'Fixed', label: 'Fixed' }]}
        onChange={event => event && field.setValue(event.value)}
      />
    </div>;
  }
  return <TextField
    id={labelProp.id}
    value={field.value ? field.value.toString() : ''}
    onChange={e => field.setValue(e.target.value)}
    fieldProps={{ ...labelProp }} />;
};

export default FieldEditor;
